import { baseUrl } from '@fs/zion-config'

const relativesConfig = {
  eventIds: {
    integration: '8ec5a2c3-166c-4676-b6be-a65291059869',
    beta: '9d146578-5139-4961-b105-f6bd1dcbae43',
    www: '8a37fa20-0398-41a6-b391-0b33657a9976',
  },
  icids: {
    landingPage: 'LP-00056462',
    homePage: 'HP-00056463',
  },
}
relativesConfig.previewUrl = `${baseUrl}/connect/${relativesConfig.eventIds.www}`

export default relativesConfig
